import gsap from 'gsap';
import Swiper from 'swiper';
import { Navigation, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';

// top news swiper
const headerNewsSwiper = document.getElementById('header-news-swiper');

if (headerNewsSwiper) {
  const swiper = new Swiper(headerNewsSwiper, {
    modules: [Navigation, Autoplay],
    init: false,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 800,
    autoplay: {
      delay: 5000,
    },

    navigation: {
      nextEl: '.js-header-news-swiper-next',
      prevEl: '.js-header-news-swiper-prev',
    },
  });
  swiper.init();
}

// nav
const header = document.getElementById('header');
const navButton = document.getElementById('nav-button');
const navItems = document.querySelectorAll('.js-nav-item');

if (header && navButton) {
  navButton.addEventListener('click', () => {
    header.classList.toggle('is-opened');
  });

  navItems.forEach((item) => {
    item.addEventListener('click', () => {
      header.classList.remove('is-opened');
      navButton.classList.remove('is-opened');
    });
  });
}

// header
const frontPage = document.getElementById('front-page');

if (frontPage && header) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      header.classList.add('is-bg-white');
    } else {
      header.classList.remove('is-bg-white');
    }
  });
}

// modal
const IS_OPENED_CLASS = 'is-opened';

const sideMenuTel = document.getElementById('side-menu-tel');
const telModal = document.getElementById('tel-modal');
const telModalCloseButtons = document.querySelectorAll('.js-tel-modal-close');

if (sideMenuTel && telModal) {
  sideMenuTel.addEventListener('click', (event) => {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      event.preventDefault();

      telModal.classList.toggle(IS_OPENED_CLASS);
    }
  });
}

if (telModal && telModalCloseButtons) {
  telModalCloseButtons.forEach((button) => {
    button.addEventListener('click', () => {
      telModal.classList.toggle(IS_OPENED_CLASS);
    });
  });
}

const secondary = document.getElementById('secondary');
const timeTalbeDetails = document.getElementById('time-table-details');
const timeTalbeSummary = document.getElementById('time-table-summary');
const timeTalbeContent = document.getElementById('time-table-content');
const timeGrayBg = document.getElementById('time-gray-bg');

if (timeTalbeDetails && timeTalbeContent) {
  timeTalbeDetails.addEventListener('click', () => {
    if (secondary) {
      secondary.classList.toggle('is-show');
    }
  });
}

if (timeGrayBg) {
  timeGrayBg.addEventListener('click', () => {
    if (secondary && timeTalbeDetails && timeTalbeSummary && timeTalbeContent) {
      secondary.classList.remove('is-show');

      timeTalbeDetails.setAttribute('open', 'false');
      const media = timeTalbeSummary.getAttribute('data-media');

      timeTalbeDetails.classList.remove(IS_OPENED_CLASS);

      if (media) {
        if (window.matchMedia(`(min-width: ${media}px)`).matches) {
          closingHorizontalAnim(timeTalbeContent, timeTalbeDetails).restart();
        } else {
          closingAnim(timeTalbeContent, timeTalbeDetails).restart();
        }
      } else {
        closingAnim(timeTalbeContent, timeTalbeDetails).restart();
      }
    }
  });
}

// access tab in about page
const aboutAccessDetails = document.querySelectorAll(
  '.js-about-access-details'
);

if (
  aboutAccessDetails.length !== 0 &&
  window.matchMedia('(min-width: 1024px)').matches
) {
  const firstAboutAccessDetails = aboutAccessDetails[0];
  const summary = firstAboutAccessDetails.querySelector('.js-summary');

  firstAboutAccessDetails.setAttribute('open', 'true');

  if (summary) {
    summary.classList.add('is-active');
  }
}

// according
document.addEventListener('DOMContentLoaded', () => {
  setUpAccordion();
});

const setUpAccordion = () => {
  const details = document.querySelectorAll('.js-details');

  details.forEach((element) => {
    const summary = element.querySelector('.js-summary');
    const content = element.querySelector('.js-content');

    if (summary && content) {
      summary.addEventListener('click', (event) => {
        if (
          summary.classList.contains('js-lg-no-animation') &&
          window.matchMedia('(min-width: 1024px)').matches
        ) {
          content.removeAttribute('style');

          const summaryElement = summary as HTMLElement;
          const tabGroupName = summaryElement.dataset.tabGroup;

          const tabSummaries = document.querySelectorAll(
            `.js-tab-summary[data-tab-group="${tabGroupName}"]`
          );

          tabSummaries.forEach((tabSummary) => {
            if (summary !== tabSummary) {
              tabSummary.classList.remove('is-active');
              const parent = tabSummary.parentElement as HTMLElement;
              parent.removeAttribute('open');
              parent.style.minHeight = '0';
            }
          });

          const parent = summary.parentElement as HTMLElement;

          if (parent.hasAttribute('open')) {
            event.preventDefault();

            return;
          }

          parent.style.minHeight = '3.8125rem';
          summary.classList.add('is-active');

          return;
        }

        event.preventDefault();

        const media = summary.getAttribute('data-media');

        if (element.classList.contains(IS_OPENED_CLASS)) {
          element.classList.toggle(IS_OPENED_CLASS);

          if (media) {
            if (window.matchMedia(`(min-width: ${media}px)`).matches) {
              closingHorizontalAnim(content, element).restart();
            } else {
              closingAnim(content, element).restart();
            }
          } else {
            closingAnim(content, element).restart();
          }
        } else {
          element.classList.toggle(IS_OPENED_CLASS);

          element.setAttribute('open', 'true');

          if (media) {
            if (window.matchMedia(`(min-width: ${media}px)`).matches) {
              openingHorizontalAnim(content).restart();
            } else {
              openingAnim(content).restart();
            }
          } else {
            openingAnim(content).restart();
          }
        }
      });
    }
  });
};

const closingAnim = (content: gsap.TweenTarget, element: Element) =>
  gsap.to(content, {
    x: 0,
    height: 0,
    opacity: 0,
    duration: 0.4,
    ease: 'power3.out',
    overwrite: true,
    onComplete: () => {
      element.removeAttribute('open');
    },
  });

const closingHorizontalAnim = (content: gsap.TweenTarget, element: Element) =>
  gsap.to(content, {
    x: '100%',
    opacity: 0,
    duration: 0.4,
    ease: 'power3.out',
    overwrite: true,
    onComplete: () => {
      element.removeAttribute('open');
    },
  });

const openingAnim = (content: gsap.TweenTarget) =>
  gsap.fromTo(
    content,
    {
      x: 0,
      height: 0,
      width: 'auto',
      opacity: 0,
    },
    {
      height: 'auto',
      opacity: 1,
      duration: 0.4,
      ease: 'power3.out',
      overwrite: true,
    }
  );

const openingHorizontalAnim = (content: gsap.TweenTarget) =>
  gsap.fromTo(
    content,
    {
      x: '100%',
      height: 'auto',
      opacity: 0,
    },
    {
      x: 0,
      opacity: 1,
      duration: 0.4,
      ease: 'power3.out',
      overwrite: true,
    }
  );

// top kv swiper
const topKvSwiper = document.getElementById('top-kv-swiper');

if (topKvSwiper) {
  const swiper = new Swiper(topKvSwiper, {
    modules: [EffectFade, Autoplay],
    init: false,
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1500,
    autoplay: {
      delay: 3000,
    },
  });
  swiper.init();
}

// facility tab
const floor = document.getElementById('floor-map');

if (floor) {
  const floorTabs = floor.querySelectorAll('.js-floor-tab');
  const floorContents = floor.querySelectorAll('.js-floor-content');

  floorTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const activeTab = floor.querySelector('.js-floor-tab.is-active');
      if (activeTab) {
        activeTab.classList.remove('is-active');
      }
      tab.classList.add('is-active');

      // 押したタブのindexを取得
      const index = Array.prototype.indexOf.call(floorTabs, tab);

      const activeContent = floor.querySelector('.js-floor-content.is-active');
      if (activeContent) {
        activeContent.classList.remove('is-active');
      }
      if (floorContents[index]) {
        floorContents[index].classList.add('is-active');
      }
    });
  });
}

// page header
const pageHeaderOrb = document.getElementById('page-header-orb');
const pageHeadderBottomOrb = document.getElementById('page-header-bottom-orb');

if (pageHeaderOrb && pageHeadderBottomOrb) {
  window.addEventListener('load', () => {
    pageHeaderOrb.classList.add('is-active');
    pageHeadderBottomOrb.classList.add('is-active');
  });
}

// fixed viewport 320px
const viewport = document.querySelector('meta[name="viewport"]');
function switchViewport() {
  const value =
    window.outerWidth > 320
      ? 'width=device-width,initial-scale=1'
      : 'width=320';
  if (viewport && viewport.getAttribute('content') !== value) {
    viewport.setAttribute('content', value);
  }
}
addEventListener('resize', switchViewport, false);
switchViewport();
